import { documentationActions } from '../../actions/constant';

const {
  REQUEST_DELETE_REQUIRED_DOCUMET,
  SUCCESS_DELETE_REQUIRED_DOCUMET,
  FAILURE_DELETE_REQUIRED_DOCUMET,
  RESET_DELETE_REQUIRED_DOCUMET,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isDocDeleted: false,
  loading: false,
};

export const deleteRequiredDocumentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_DELETE_REQUIRED_DOCUMET: {
      return {
        ...state,
        isDocDeleted: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_DELETE_REQUIRED_DOCUMET:
      return {
        ...state,
        isDocDeleted: false,
        response: action.payload,
        loading: false,
      };

    case REQUEST_DELETE_REQUIRED_DOCUMET:
      return {
        ...state,
        loading: true,
      };

    case RESET_DELETE_REQUIRED_DOCUMET:
      return intitialstate;

    default:
      return state;
  }
};
